
import Link from 'next/link';
import { Icon } from './icon';
import { cn } from '@/lib/utils';

/** An icon on its own in the public header: a round hit area, a name for screen readers, and
 *  an optional count riding the corner. Both tones exist because this header is solid midnight
 *  on some pages and white on others. */
export function IconLink({
  href,
  icon,
  label,
  tone = 'light',
  badge,
  size = 19,
  className,
}: {
  href: string;
  icon: string;
  label: string;
  tone?: 'light' | 'dark';
  /** Shown only when above zero; anything past nine reads as "9+". */
  badge?: number;
  size?: number;
  className?: string;
}) {
  return (
    <Link
      href={href}
      aria-label={label}
      className={cn(
        'relative inline-flex h-9 w-9 items-center justify-center rounded-full transition-colors',
        tone === 'dark'
          ? 'text-white/80 hover:bg-white/10 hover:text-white'
          : 'text-muted-foreground hover:bg-muted hover:text-foreground',
        className,
      )}
    >
      <Icon name={icon} size={size} />
      {badge !== undefined && badge > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-highlight-soft px-1 text-[0.625rem] font-bold text-highlight-foreground">
          {badge > 9 ? '9+' : badge}
        </span>
      )}
    </Link>
  );
}
